/**
 * The app shell (@vnetwork/datacentral-ui DashboardLayout) scrolls its `<main>` element,
 * not the window — scroll helpers must target it.
 */
export const getAppScroller = (): HTMLElement | null =>
    document.querySelector<HTMLElement>('main') ??
    (document.scrollingElement as HTMLElement | null)

export const scrollAppToTop = (behavior: ScrollBehavior = 'smooth') =>
    getAppScroller()?.scrollTo({ top: 0, behavior })
